"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  FALLBACK_ENV: () => FALLBACK_ENV,
  FEATURE_FLAG_KEYS: () => FEATURE_FLAG_KEYS,
  getConfigValue: () => getConfigValue,
  getFeatureFlag: () => getFeatureFlag,
  getFeatureFlagMap: () => getFeatureFlagMap,
  getFeatureFlags: () => getFeatureFlags,
  resolveEnvironment: () => resolveEnvironment
});
module.exports = __toCommonJS(index_exports);

// src/environment.utils.ts
var FALLBACK_ENV = "black";
var SUPPORTED_ENVIRONMENTS = /* @__PURE__ */ new Set([
  "black",
  "white",
  "orange"
]);
var isEnvironmentName = /* @__PURE__ */ __name((value) => typeof value === "string" && SUPPORTED_ENVIRONMENTS.has(value), "isEnvironmentName");
var resolveEnvironment = /* @__PURE__ */ __name((env) => isEnvironmentName(env) ? env : FALLBACK_ENV, "resolveEnvironment");

// src/data/feature-flags.json
var feature_flags_default = {
  ibh_useFilterReleaseLocales: {
    black: true,
    white: false,
    orange: false
  },
  ibh_usePostgresMaterialsDescription: {
    black: true,
    white: true,
    orange: true
  }
};

// src/feature-flags.handler.ts
var FEATURE_FLAG_KEYS = Object.keys(feature_flags_default);
var getFeatureFlag = /* @__PURE__ */ __name((key, env) => {
  const resolvedEnv = resolveEnvironment(env);
  return feature_flags_default[key][resolvedEnv];
}, "getFeatureFlag");
var getFeatureFlags = /* @__PURE__ */ __name((env) => FEATURE_FLAG_KEYS.map((flagName) => ({
  name: flagName,
  value: getFeatureFlag(flagName, env)
})), "getFeatureFlags");
var getFeatureFlagMap = /* @__PURE__ */ __name((env) => new Map(getFeatureFlags(env).map(({ name, value }) => [
  name,
  value
])), "getFeatureFlagMap");

// src/data/configs.json
var configs_default = {
  newMyigusLocalesConfig: {
    black: ["all"],
    white: ["all"],
    orange: ["en-GB", "en-IE", "de-DE", "de"]
  }
};

// src/config.handler.ts
var getConfigValue = /* @__PURE__ */ __name((key, env) => {
  const resolvedEnv = resolveEnvironment(env);
  return configs_default[key][resolvedEnv];
}, "getConfigValue");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  FALLBACK_ENV,
  FEATURE_FLAG_KEYS,
  getConfigValue,
  getFeatureFlag,
  getFeatureFlagMap,
  getFeatureFlags,
  resolveEnvironment
});
